// src/utils/formDataUtils.js

export const districts = [
  "Chennai",
  "Kancheepuram",
  "Viluppuram",
  "Thiruvannamalai",
  "Cuddalore",
  "Thiruchirappalli",
  "Salem",
  "Dharmapuri",
  "Krishnagiri",
  "Vellore",
  "Ranipet",
  "Thanjavur",
  "Tiruppur",
  "Coimbatore",
  "Puducherry",
  "Karaikal",
  "Madurai",
  "Theni",
  "Virudhunagar",
  "Tirunelveli",
  "Nagapattinam",
  "Mayiladuthurai",
  "Mumbai",
  "Thiruvananthapuram",
  "Kollam"
];

export const districtTamilNames = {
  Chennai: "சென்னை",
  Kancheepuram: "காஞ்சிபுரம்",
  Viluppuram: "விழுப்புரம்",
  Thiruvannamalai: "திருவண்ணாமலை",
  Cuddalore: "கடலூர்",
  Thiruchirappalli: "திருச்சிராப்பள்ளி",
  Salem: "சேலம்",
  Dharmapuri: "தர்மபுரி",
  Krishnagiri: "கிருஷ்ணகிரி",
  Vellore: "வேலூர்",
  Ranipet: "ராணிப்பேட்டை",
  Thanjavur: "தஞ்சாவூர்",
  Tiruppur: "திருப்பூர்",
  Coimbatore: "கோயம்புத்தூர்",
  Puducherry: "புதுச்சேரி",
  Karaikal: "கரைக்கால்",
  Madurai: "மதுரை",
  Theni: "தேனி",
  Virudhunagar: "விருதுநகர்",
  Tirunelveli: "திருநெல்வேலி",
  Nagapattinam: "நாகப்பட்டினம்",
  Mayiladuthurai: "மயிலாடுதுறை",
  Mumbai: "மும்பை",
  Thiruvananthapuram: "திருவனந்தபுரம்",
  Kollam: "கொள்ளம்",
};


export const states = ["Tamil Nadu", "Other"];

export const stars = [
  "Ashwini", "Bharani", "Krithikai", "Rohini", "Mirgasheersham", "Thiruvaathirai",
  "Punarpoosam", "Poosam", "Aayilyam", "Makam", "Pooram", "Uthiram", "Hastham",
  "Chithirai", "Swaathi", "Visaakam", "Anusham", "Kettai", "Moolam", "Pooraadam",
  "Uthiraadam", "Thiruvonam", "Avittam", "Chathayam/Sadayam", "Poorattathi",
  "Uthirattathi", "Revathi"
];

export const raasis = [
  "Mesham", "Risabham", "Mithunam", "Kadagam", "Simmam", "Kanni",
  "Thulam", "Viruchigam", "Dhanushu", "Magaram", "Kumbham", "Meenam"
];

export const maritalStatusOptions = ["Single", "Married"];

export const idProofTypes = [
  { value: "aadhaar", label: "Aadhaar" },
  { value: "license", label: "License" }
];

export const panCardOptions = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" }
];

export const roleOptions = [
  { value: "superuser", label: "Super User" },
  { value: "admin", label: "Admin" },
  { value: "user", label: "User" },
];